import axios from 'axios';

// All requests use the deployment API, with a local backend in development.
const baseURL =
  import.meta.env.VITE_API_URL?.trim().replace(/\/+$/, '') ||
  (import.meta.env.PROD ? 'https://backend.panah.io' : 'http://localhost:5001');
const api = axios.create({
  baseURL,
  timeout: 20000, // افزایش تایم‌اوت به ۲۰ ثانیه
});

// اضافه کردن توکن به درخواست‌ها
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// مدیریت خطاها
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // اگر خطای 401 (عدم احراز هویت) داد، کاربر را لاگ‌اوت کن
    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes('/auth')
    ) {
      // localStorage.removeItem('token');
      // window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

export default api;
